
export abstract class UserPreferenceService {
	public abstract config(): Promise<null>;
	public abstract getOpenActivityInModalPreference(): boolean;
	public abstract getCloseAfterActivitySavePreference(): boolean;
	public abstract getWideModalPreference(): boolean;
	public abstract getDossierExpandedStatePreference(): boolean;
	public abstract getKeyValue(key: string): string;
	public abstract setKeyValue(key: string, value: string);
}